import { ENTER_KEY_DOWN } from 'constants';
import { useEffect } from 'react';
import useCommonStore from './useCommonStore';
import { useDetectDevice } from './useDetectDevice';
import useThrottle from './useThrottle';

const useEnterKeyDown = (
  isUseKeyDown,
  cb = () => {},
  isUseKeyDownException
) => {
  const { isDesktop } = useDetectDevice();
  const { throttle } = useThrottle(1);
  const { isLoading } = useCommonStore();

  useEffect(() => {
    const listener = (e) => {
      if (isLoading) return;
      if ((isUseKeyDownException || isDesktop) && isUseKeyDown) {
        const { key } = e;
        if (key === ENTER_KEY_DOWN) {
          throttle(() => cb());
        }
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [isUseKeyDown, isLoading, isUseKeyDownException, cb]);
};

export default useEnterKeyDown;
